module.exports = {"542426100":"申扎镇","542426101":"雄梅镇","542426200":"马跃乡","542426201":"买巴乡","542426202":"塔尔玛乡","542426203":"下过乡","542426204":"卡乡","542426205":"巴扎乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542426.json
// module id = 2899
// module chunks = 0